module.exports = __webpack_public_path__ + "static/img/voice.250d23a.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/english/home/pc/role/voice.gif
// module id = vKwe
// module chunks = 0